import React from "react";
import PropTypes from "prop-types";
// import cx from "classnames";
import { Form, 
    Button, Icon, 
    Modal, 
    List, 
    Radio,
    Statistic,
    Row,
    DatePicker,
    Col,
    message} from "antd";
import { OrderedMap } from "immutable";
import { INPUT_TYPES } from "constants";
import {
    fieldGenerator,
    getValidateStatus
} from "utilities/form";
import moment from "moment";

const FEE_CALCULATION_TYPES = {
    0: "UNDEFINED",
    1: "FIXED",
    2: "PERCENTAGE"
};

const FEE_CALCULATION_LABELS = {
    UNDEFINED: " ",
    FIXED: "₹",
    PERCENTAGE: "%",
};

const getFormFields = () => new OrderedMap({
    frequency: {
        key: "frequency",
        label: "Installment Frequency",
        dataIndex: "frequency",
        className: "form-field m-0",
        type: INPUT_TYPES.OBJECT_SELECT,
        options: [
            {id: 0, name: "Weekly"},
            {id: 1, name: "Monthly"},
        ],
        labelProp: "name",
        rules:[{
            required: true,
            message: "Please select a Installment Frequency"
        }]
    },
});

const START_DATE = "from_date";

class CompanyPrePaymentChargeForm extends React.Component {
    state = {
        feeMaster: "",
        from_date: this.props.feeData && this.props.feeData.toJS().from_date? moment(this.props.feeData && this.props.feeData.toJS().from_date, "YYYY-MM-DD"):null
    };

    formFields = getFormFields();
    fieldGenerator = fieldGenerator.bind(this.props.form);
    // getErrorOnField = getErrorOnField.bind(this.props.form);
    getValidateStatus = getValidateStatus.bind(this.props.form);
    onValuesSubmit = e => {
        e.preventDefault();
        if (!this.props.loading) {
            this.props.form.validateFields((err, values) => {
                if (!err && this.state.feeMaster && (this.state.from_date || this.props.update)) {
                    let newValues = values;
                    newValues.frequency = newValues.frequency && newValues.frequency.id;
                    newValues.foreclosure_master = this.state.feeMaster;
                    newValues.from_date = this.state.from_date && this.state.from_date.format("YYYY-MM-DD");
                    this.props.onValuesSubmit(newValues);
                }else{
                    message.error("Please enter valid values!");
                }
            });
        }
    }

    getCharge = (type, charge) => {
        if(type === 1){
            return FEE_CALCULATION_LABELS[FEE_CALCULATION_TYPES[type]]+charge;
        }else if(type === 2) {
            return charge+FEE_CALCULATION_LABELS[FEE_CALCULATION_TYPES[type]];
        }
        return charge;
    }

    handleDateInput = (type, _) => {
        this.setState({
            [type]: _
        });
    };

    renderItem = (_, k) => {
        if(!this.props.update && _.configuration && _.configuration.length === 0){
            return <div/>;
        }
        return (
            <List.Item onClick={() => this.setState({feeMaster: _.foreclosure_master.id})}  className={"d-flex cursor-pointer align-items-start justify-content-flex-start flex-column"} key={k}>
                <h3>
                    {_.name || _.foreclosure_master.name}
                </h3>
                <div className={"d-flex w-100"}>
                    <Radio 
                        onClick={() => this.setState({feeMaster: _.foreclosure_master.id})}
                        className={"m-10"}
                        checked={this.state.feeMaster === _.foreclosure_master.id}
                    />
                    <div className={"w-100 d-flex flex-column"}>
                        {(_.foreclosure_master.configuration).map((__, key) => 
                            <Row className={"w-100 m-10"} key={key}>
                                <Col span={8}>
                                    <Statistic 
                                        valueStyle={{
                                            fontSize: "16px",
                                            fontWeight: 600
                                        }} 
                                        title={"From Tenure"}
                                        value={__.from_tenure}
                                    />
                                </Col>
                                <Col span={8}>
                                    <Statistic 
                                        valueStyle={{
                                            fontSize: "16px",
                                            fontWeight: 600
                                        }} 
                                        title={"To Tenure"}
                                        value={__.to_tenure}
                                    />
                                </Col>
                                <Col span={8}>
                                    <Statistic 
                                        valueStyle={{
                                            fontSize: "16px",
                                            fontWeight: 600
                                        }} 
                                        title={"Charge"}
                                        value={this.getCharge(__.fee_calculation_type, __.value)}
                                    />
                                </Col>
                            </Row>
                        )}
                    </div>
                </div>
            </List.Item>
        );
    }


    disabledDate = (current) => {
        // Disable dates before today (previous dates)
        return current && current < moment().startOf('day');
    }

    
    render() {
        return (
            <Modal 
                width={800}
                bodyStyle={{
                    paddingRight: "6rem",
                    paddingLeft: "6rem"
                }}
                footer={null}
                title="Add/Update Pre Payment Program"
                visible={this.props.visible}
                onCancel={this.props.toggleModal}
            >
                <Form onSubmit={this.onValuesSubmit}>
                {!this.props.update && <div className={"form-row align-items-center"}>
                        {this.formFields.map((field, fieldName) => {
                        
                          
                            return this.fieldGenerator(
                                fieldName,
                                field,
                                this.getValidateStatus(fieldName)
                            )();
                        }).toList()}

                        <Row>
                        <Col span={12}>
                            <div className={"displayInline w-100"}>
                                <p className={"required-field"} style={{margin: "0px", paddingBottom: "8px"}}>From Date:</p><b/>
                                <div style={{padding: "10 0 10 0"}}>
                                    <DatePicker
                                        disabledDate={this.disabledDate}
                                        style={{
                                            width: "100% !important"
                                        }}
                                        size={"default"}
                                        className={"w-date-picker"}
                                        onChange={this.handleDateInput.bind(
                                            null,
                                            START_DATE
                                        )}
                                        value={this.state.from_date}
                                        required={true}
                                        placeholder={"From Date"}
                                    />
                                </div>
                            </div>
                        </Col>
                        </Row>
                    </div>}
                    <List
                        border={false}
                        className={"border-none"}
                        header={null}
                        bordered
                        footer={null}
                        dataSource={this.props.prePaymentChargesMaster}
                        renderItem={this.renderItem}
                    />
                    <div className={"form-row flex-row-reverse p-10"}>
                        <Button type={"primary"} htmlType={"submit"} disabled={this.props.loading}>
                            {this.props.loading ? <Icon type={"loading"} /> : null}
                            Add/Update
                        </Button>
                    </div>
                </Form>
            </Modal>
        );
    }
}

CompanyPrePaymentChargeForm.propTypes = {
    form: PropTypes.object,
    values: PropTypes.array,
    onValuesSubmit: PropTypes.func,
    loading: PropTypes.bool,
    visible: PropTypes.visible,
    toggleModal: PropTypes.func,
    feeMaster: PropTypes.array,
    prePaymentChargesMaster: PropTypes.array
};

export default Form.create({})(CompanyPrePaymentChargeForm);